let isUpdatingCartDrawer = false;
let sectionsToFetch = 'cart-drawer';

document.addEventListener('on:cart:loaded', (event) => {
  if (event.detail.type === 'ADD') {
    document.querySelector('.js-cart-drawer')?.scrollTo(0, 0, { behavior: 'smooth'})

    fetchCartDrawer(true);
  }
});

/**
 * Fetches the cart drawer content and updates the cart drawer
 */

function fetchCartDrawer(showCartDrawer = false, isShopPay = false) {
  if (isShopPay) {
    window.location.href = '/checkout?payment=shop_pay';
  } else if (!isUpdatingCartDrawer) {
    isUpdatingCartDrawer = true;

    fetch(`${window.Shopify.routes.root}cart?sections=${sectionsToFetch}`)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const sections = data;

        // Updates the cart drawer
        fetch(`${window.Shopify.routes.root}cart.js`)
          .then((response) => {
            return response.json();
          })
          .then((cartData) => {
            cartData['sections'] = sections;

            updateCartDrawer(cartData, showCartDrawer);

            if (cartData.attributes.hasOwnProperty('error_discount_codes')) {
              fetch(`${window.Shopify.routes.root}cart/update.js`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  attributes: {
                    error_discount_codes: '',
                  }
                })
              });
            }
          })
          .catch((error) => {
            console.error(error);
          });
      })
      .catch((error) => {
        console.error(error);
      });
    }
}

/**
 * Updates the cart drawer
 *
 * @param {string} data - The data to update the cart drawer with
 */
async function updateCartDrawer(data, showCartDrawer = false) {
  try {
    if (!!(data)) {
      const cartDrawer = document.querySelector('.js-cart-drawer');
      const cartModal = document.querySelector('.modal--cart');

      if (!!(cartDrawer)) {
        const cartCountBubble = document.querySelectorAll('.cart-count-bubble items-count');
        const cartDrawerHTML = new DOMParser().parseFromString(data?.sections['cart-drawer'], 'text/html');
        const cartDrawerContainer = cartDrawer.querySelector('.js-cart--draw');
        const cartQuantityInfo = cartDrawer.querySelector('.js-cart-draw__quantity-info items-count');
        let cartControls = cartDrawer.querySelector('.js-cart__controls');

        if (Object.keys(data?.sections).length > 1) {
          for (const section of Object.entries(data?.sections)) {
            if (section[0] !== 'cart-drawer') {
              const sectionHTML = new DOMParser().parseFromString(section[1], 'text/html');
              const sectionContainer = document.getElementById(`shopify-section-${section[0]}`);

              if (!!(sectionContainer)) {
                sectionContainer.innerHTML = sectionHTML.querySelector('.shopify-section')?.innerHTML;
              }
            }
          }
        }

        if (!!(cartDrawerContainer)) {
          cartDrawerContainer.innerHTML = cartDrawerHTML.querySelector('.js-cart--draw')?.innerHTML;
        }

        const cartDrawerContent = cartDrawer.querySelector('.js-cart__contents');

        if (!!(cartQuantityInfo)) {
          if (!!(cartDrawerContent)) {
            cartQuantityInfo.innerHTML = cartDrawerHTML.querySelector('.js-cart-draw__quantity-info items-count')?.innerHTML;
          } else {
            cartQuantityInfo.innerHTML = '0';
          }
        }

        if (!!(cartCountBubble) && cartCountBubble.length > 0) {
          cartCountBubble.forEach((countBubble) => {
            if (!!(cartDrawerContent)) {
              countBubble.innerHTML = cartDrawerHTML.querySelector('.js-cart-draw__quantity-info items-count')?.innerHTML;
            } else {
              countBubble.innerHTML = '0';
            }
          });
        }

        if (!!cartModal) {
          if (!cartModal.shown && showCartDrawer) {
            cartModal.open();
          } else if (cartModal.interval) {
            cartModal.interval.reset();
            cartModal.interval.start();
          }
        }
        
        if (data.item_count > 0) {
          const cartItems = data?.items;

          if (cartItems.length > 0) {
            if (!cartDrawerContainer.querySelector('[data-enable-searchspring="true"]')) {
              const newRecommendations = {};
              const outputRecommendations = [];
              const productIds = cartItems.reduce(((ids, item) => {
                if (!item.gift_card && !ids.includes(item.product_id.toString())) ids.push(item.product_id.toString());
                return ids;
              }), []);
              let recommendationsLimit = 6;

              if (productIds.length >= 3) {
                recommendationsLimit = 2;
              } else if (productIds.length >= 2) {
                recommendationsLimit = 4;
              }

              await Promise.all([...productIds].map((async productId => {
                const response = await fetch(`${window.Shopify.routes.root}recommendations/products?section_id=cart-drawer-recommendations&product_id=${productId}&limit=${recommendationsLimit}&intent=related`);
                const recommendationsHTML = await response.text();
                const recommendationsJSON = new DOMParser().parseFromString(recommendationsHTML, 'text/html').querySelector('.shopify-section').textContent.trim();

                let recommendations = {};

                if (recommendationsJSON.startsWith('{') && recommendationsJSON.endsWith('}')) {
                  recommendations = JSON.parse(recommendationsJSON);
                }

                if (recommendations?.products) {
                  Object.entries(recommendations?.products)?.forEach(([key, value]) => {
                    if (!Object.keys(newRecommendations)?.includes(key.toString())) {
                      outputRecommendations.push(value);
                    }

                    newRecommendations[key.toString()] = true;
                  });

                  if (outputRecommendations.length <= recommendationsLimit) {
                    recommendationsLimit = 2;
                  }
                }
              })));

              const cartRecommendations = cartDrawerContainer.querySelector('.js-cart-recommendations');

              if (!!(cartRecommendations)) {
                cartRecommendations.innerHTML = outputRecommendations.slice(0, 6).join('');
              }
            } else {
              const recommendationsScript = cartDrawerContainer.querySelector('script[data-section-id="drawer-cart-recommendations"]');

              if (!!(recommendationsScript)) {
                const tag = recommendationsScript.dataset.tag;
                const limit = recommendationsScript.dataset.limit;
                const placement = recommendationsScript.dataset.placement;
                const recommendationsUrl = recommendationsScript.dataset.recommendationsUrl;
                const cartProductIds = recommendationsScript.dataset.cartProductIds;

                var storedProducts = sessionStorage.getItem('recently_viewed_products');
                var viewedProducts = [];
                var viewedProductIds = [];

                if (storedProducts && storedProducts.startsWith("[")) {
                  viewedProducts = JSON.parse(storedProducts);

                  viewedProducts.forEach((productIdentifier) => {
                    viewedProductIds.push(productIdentifier.split(':')[1]);
                  });
                }

                fetch(`${recommendationsUrl.replace('REPLACE_TAG', tag)}&cart=${cartProductIds}&lastViewed=${viewedProductIds.join(',')}`,
                  {
                    method: 'GET',
                    headers: {
                      accept: 'application/json'
                    }
                  })
                  .then((response) => response.json())
                  .then((data) => {
                    const productCardSection = document.querySelector('[data-section-id="drawer-cart-recommendations"] .grid-layout');

                    initRecommendationsSection(productCardSection, tag, data, limit, placement);
                  })
                  .catch((error) => console.error(error));
              }
            }
          }
        }

        cartControls = cartDrawer.querySelector('.js-cart__controls');

        if (!!(cartControls) && !!(cartDrawer)) {
          cartDrawer.parentElement.style.setProperty('--cart-drawer-footer-height', `${cartControls.offsetHeight}px`);
        } else if (!!(cartDrawer)) {
          cartDrawer.parentElement.style.setProperty('--cart-drawer-footer-height', `0px`);
        }
      }
    }
  } catch (error) {
    console.error(error);
  } finally {
    isUpdatingCartDrawer = false;
  }
}

/**
 * Adds an item to the cart
 *
 * @param {FormData} formData - The form data to add the item to the cart with
 * @param {Boolean} isShopPay - Whether or not Shop Pay accelerated checkout
 *                              button was used to add the product and
 *                              therefore should have the user redirected to
 *                              checkout using Shop Pay.
 */
function cartAdd(formData, isShopPay = false) {
  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    body: formData
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      fetchCartDrawer(true, isShopPay);
    })
    .catch((error) => {
      console.error(error);
    });
}

/**
 * Changes line item quantity
 *
 * @param {Object} change - The item to update
 * @param {Boolean} updateDrawer - Whether to update the cart drawer
 */
function cartChange(change, updateDrawer = true) {
  fetch(`${window.Shopify.routes.root}cart/change.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(change)
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      // Updates the cart drawer

      if (updateDrawer) {
        updateCartDrawer(data, true);
      }
    })
    .catch((error) => {
      console.error(error);
    });
}

/**
 * Updates line items
 *
 * @param {Object} updates - The items to update
 * @param {Boolean} updateDrawer - Whether to update the cart drawer
 */
function cartUpdate(updates, updateDrawer = true) {
  fetch(`${window.Shopify.routes.root}cart/update.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(updates)
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      // Updates the cart drawer

      if (updateDrawer) {
        updateCartDrawer(data, true);
      }
    })
    .catch((error) => {
      console.error(error);
    });
}

document.addEventListener('DOMContentLoaded', function() {
  const cartControls = document.querySelector('.js-cart__controls');
  const cartDrawer = document.querySelector('.js-cart-drawer');
  const cartItemRemoves = document.querySelectorAll('.js-cart-item__remove');
  const cartModal = document.querySelector('.modal--cart');
  const quantityInputs = document.querySelectorAll('.js-cart-quantity-input');

  fetchCartDrawer(false);

  document.querySelectorAll('.shopify-section-group-gwp')?.forEach((section) => {
    sectionsToFetch += `,${section.id.replace('shopify-section-', '')}`;
  });

  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.has('cart') && urlParams.get('cart') === 'true') {
    if (!!cartModal) {
      if (!cartModal.shown) {
        cartModal.open();
      } else if (cartModal.interval) {
        cartModal.interval.reset();
        cartModal.interval.start();
      }
    }
  }

  if (urlParams.has('pc')) {
    const promoCode = urlParams.get('pc');
    const sentDiscountCodes = [];

    sentDiscountCodes.push(promoCode);

    fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          discount: promoCode
        })
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          let appliedDiscountCode = '';
          let errorDiscountCode = '';
          let foundDiscountCodes = [];

          if (data.hasOwnProperty('discount_codes') && Object.values(data.discount_codes).length > 0) {
            foundDiscountCodes = Object.values(data.discount_codes || {})
              .filter(d => d.applicable)
              .map(d => d.code);
            appliedDiscountCode = foundDiscountCodes.join(',');
          }

          sentDiscountCodes.forEach((sentDiscountCode) => {
            if (!foundDiscountCodes.includes(sentDiscountCode)) {
              errorDiscountCode += `${sentDiscountCode},`;
            }
          });

          if (errorDiscountCode !== '') {
            errorDiscountCode = errorDiscountCode.slice(0, -1);
          }

          return fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              attributes: {
                applied_discount_codes: appliedDiscountCode,
                error_discount_codes: errorDiscountCode,
              },
            }),
          });
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          // Updates the cart drawer
          fetchCartDrawer();
        });
  }

  if (!!(cartItemRemoves) && cartItemRemoves.length > 0) {
    cartItemRemoves.forEach((cartItemRemove) => {
      cartItemRemove.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (event.currentTarget.hasAttribute('data-is-cgc')) {
          event.currentTarget.closest('.cart-item').remove();

          const updates = {
            attributes: {}
          };

          updates.attributes[event.currentTarget.dataset.key.replace('been_offered', 'denied')] = 'true';

          fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(updates)
          })
            .catch((error) => {
              console.error(error);
            })
            .finally(() => {
              fetchCartDrawer(true);
            });
        } else {
          cartChange({
            id: event.currentTarget.dataset.key,
            quantity: 0,
            sections: sectionsToFetch
          });
        }
      });
    });
  }

  if (!!(quantityInputs) && quantityInputs.length > 0) {
    quantityInputs.forEach((input) => {
      input.addEventListener('update', (event) => {
        event.stopImmediatePropagation();

        const updates = {};

        updates[event.detail.key] = Number(event.detail.value);

        cartUpdate({
          updates,
          sections: sectionsToFetch
        });
      });
    });
  }

  if (!!(cartControls) && !!(cartDrawer)) {
    cartDrawer.parentElement.style.setProperty('--cart-drawer-footer-height', `${cartControls.offsetHeight}px`);
  }

  const cartObserver = new MutationObserver((mutations, observer) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const cartItemRemoves = node.querySelectorAll('.js-cart-item__remove');
          const quantityInputs = node.querySelectorAll('.js-cart-quantity-input');

          if (!!(cartItemRemoves) && cartItemRemoves.length > 0) {
            cartItemRemoves.forEach((cartItemRemove) => {
              cartItemRemove.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();

                if (event.currentTarget.hasAttribute('data-is-cgc')) {
                  event.currentTarget.closest('.cart-item').remove();

                  const updates = {
                    attributes: {}
                  };

                  updates.attributes[event.currentTarget.dataset.key.replace('been_offered', 'denied')] = 'true';

                  fetch(`${window.Shopify.routes.root}cart/update.js`, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(updates)
                  })
                    .catch((error) => {
                      console.error(error);
                    })
                    .finally(() => {
                      fetchCartDrawer(true);
                    });
                } else {
                  cartChange({
                    id: event.currentTarget.dataset.key,
                    quantity: 0,
                    sections: sectionsToFetch
                  });
                }
              });
            });
          }

          if (!!(quantityInputs) && quantityInputs.length > 0) {
            quantityInputs.forEach((input) => {
              input.addEventListener('update', async (event) => {
                event.stopImmediatePropagation();

                const updates = {};

                updates[event.detail.key] = Number(event.detail.value);

                cartUpdate({
                  updates,
                  sections: sectionsToFetch,
                });
              });
            });
          }
        }
      });
    });
  });

  cartObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  /**
   * Gift with Purchase
   */

  let gwpSections = document.querySelectorAll('.shopify-section-group-gwp');
  let gwpItems = document.querySelectorAll('[name="gwp"]');
  let gwpUpdates = [];

  if (!!(gwpItems) && gwpItems.length > 0) {
    gwpItems.forEach((gwp) => {
      if (gwp.dataset.type === 'add' && gwp.value.startsWith('{')) {
        const data = JSON.parse(gwp.value);
        const uuid = window.crypto.randomUUID();

        if (data.hasOwnProperty('add')) {
          data.add.properties['_uuid'] = uuid;

          gwpUpdates.push(fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data.add)
          }));
        }

        setTimeout(() => {
          gwpUpdates.push(fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data.update)
          }));
        }, 1000);

        gwp.remove();
      } else if (gwp.dataset.type === 'remove' && node.value.startsWith('{')) {
        gwpUpdates.push(fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(JSON.parse(gwp.value))
        }));

        gwp.remove();
      }
    });

    Promise.all(gwpUpdates)
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setTimeout(() => {
          fetchCartDrawer(false);
        }, 1000);
      });
  }

  const gwpObserver = new MutationObserver((mutations, observer) => {
    mutations.forEach((mutation) => {
      gwpUpdates = [];

      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          gwpSections = document.querySelectorAll('.shopify-section-group-gwp');

          if (!!(gwpSections) && gwpSections.length > 0) {
            gwpSections.forEach((section) => {
              if (!section.hasAttribute('data-is-being-observed')) {
                gwpObserver.observe(section, {
                  childList: true,
                  subtree: true
                });

                section.setAttribute('data-is-being-observed', 'true');
              }
            });
          }

          if (node.dataset.type === 'add' && node.value.startsWith('{')) {
            const data = JSON.parse(node.value);
            const uuid = window.crypto.randomUUID();

            if (data.hasOwnProperty('add')) {
              data.add.properties['_uuid'] = uuid;

              gwpUpdates.push(fetch(`${window.Shopify.routes.root}cart/add.js`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(data.add)
              }));
            }

            setTimeout(() => {
              gwpUpdates.push(fetch(`${window.Shopify.routes.root}cart/update.js`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(data.update)
              }));
            }, 1000);

            node.remove();
          } else if (node.dataset.type === 'remove' && node.value.startsWith('{')) {
            gwpUpdates.push(fetch(`${window.Shopify.routes.root}cart/update.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(JSON.parse(node.value))
            }));

            node.remove();
          }
        }
      });

      Promise.all(gwpUpdates)
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setTimeout(() => {
            fetchCartDrawer(false);
          }, 1000);
        });
    });
  });

  if (!!(gwpSections) && gwpSections.length > 0) {
    gwpSections.forEach((section) => {
      gwpObserver.observe(section, {
        childList: true,
        subtree: true
      });

      section.setAttribute('data-is-being-observed', 'true');
    });
  }
});

/**
 * Item Personalization
 */

if (!customElements.get('item-personalization')) {
  customElements.define('item-personalization', class ItemPersonalization extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.editButton = this.querySelector('.js-cart-item__personalization__header__edit-button');
      this.formInputs = this.querySelectorAll('input');
      this.saveButton = this.querySelector('.js-cart-item__personalization__edit-form__save-button');

      this.initialProperties = {};

      if (!!(this.formInputs) && this.formInputs.length > 0) {
        this.formInputs.forEach((input) => {
          this.initialProperties[input.name] = input.value;
        });
      }

      this.editButton.addEventListener('click', this.handleEditButtonClick.bind(this));
      this.saveButton.addEventListener('click', this.handleSaveButtonClick.bind(this));
    }

    /**
     * Handles the edit button click
     *
     * @param {Event} event - The event object
     */
    handleEditButtonClick(event) {
      this.toggleAttribute('data-is-editing');
    }

    /**
     * Handles the save button click
     *
     * @param {Event} event - The event object
     */
    handleSaveButtonClick(event) {
      if (!!(this.formInputs) && this.formInputs.length > 0) {
        const currentProperties = {};
        const changeData = {
          id: this.dataset.itemKey,
          quantity: Number(this.dataset.itemQuantity),
        };
        let hasProperties = false;

        this.formInputs.forEach((input) => {
          currentProperties[input.name] = input.value;
        });

        if (JSON.stringify(currentProperties) === JSON.stringify(this.initialProperties)) {
          this.toggleAttribute('data-is-editing');

          return;
        }

        this.formInputs.forEach((input) => {
          if (!hasProperties && input.name.startsWith('properties[') && !input.name.startsWith('properties[_')) {
            hasProperties = true;

            changeData['properties'] = {};
          }

          if (input.name === 'properties[_personalization]') {
            const personalizationFormData = [];

            this.formInputs.forEach((input) => {
              if (input.hasAttribute('data-key')) {
                personalizationFormData.push({
                  key: input.dataset.key,
                  value: input.value,
                });
              }
            });

            input.value = JSON.stringify(personalizationFormData);
          }

          changeData['properties'][input.name.replace('properties[', '').replace(']', '')] = input.value;
        });

        fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(changeData)
        })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.removeAttribute('data-is-editing');

            // Updates the cart drawer
            fetchCartDrawer(true);
          });
      }
    }
  });
}

/**
 * Accelerated Checkout Buttons
 */

if (!customElements.get('accelerated-checkout-buttons')) {
  customElements.define('accelerated-checkout-buttons', class AcceleratedCheckoutButtons extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.buttons = this.querySelectorAll('.dynamic-button');
      this.component = this.dataset.component;

      this.buttons.forEach((button) => {
        button.addEventListener('click', this.handleClick.bind(this));
      });

      // Checks if the device is an Apple device
      if (window.ApplePaySession) {
        this.querySelector('.dynamic-button--apple-pay')?.removeAttribute('hidden');
        this.querySelector('.dynamic-button--apple-pay')?.parentElement.setAttribute('data-button-count', 3);
      }
    }

    handleClick(event) {
      const button = event.target;
      const buttonType = button.dataset.buttonType;
      const form = button.closest('form');

      if (!!(form)) {
        form.insertAdjacentHTML('beforeend', `<input type="hidden" name="return_to" value="/checkout${(buttonType === 'shop-pay') ? '?payment=shop_pay' : ''}">`);

        if (this.component === 'product-form') {
          fetch('/cart/clear.js')
            .then(() => {
              form.submit();
            })
            .catch((error) => {
              console.error(error);
            });
        } else if (this.component === 'cart-details') {
          form.submit();
        }
      }
    }
  });
}

/**
 * Cart Add-Ons
 */

if (!customElements.get('cart-addon')) {
  customElements.define('cart-addon', class CartAddon extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.input = this.querySelector('input');

      if (!!(this.input)) {
        this.input.addEventListener('change', this.handleChange.bind(this));
      }
    }

    handleChange(event) {
      let addonKey = '';
      let parentKey = this.input.dataset.parentKey;
      let parentUUID = this.input.dataset.parentUuid;

      if (event.currentTarget.hasAttribute('data-key')) {
        addonKey = event.currentTarget.dataset.key;
      }

      if (event.currentTarget.checked && this.input.dataset.parentProperties.startsWith('[')) {
        const parentProperties = Object.fromEntries(JSON.parse(this.input.dataset.parentProperties));

        if (parentProperties.hasOwnProperty('_add_on_variants')) {
          parentProperties['_add_on_variants'] = JSON.parse(parentProperties['_add_on_variants']);

          parentProperties['_add_on_variants'].push({
            'id': this.input.value,
            'add_on_type': this.input.dataset.type,
            'cost': Number(this.input.dataset.price),
          });
        } else {
          parentProperties['_add_on_variants'] = [];

          parentProperties['_add_on_variants'].push({
            'id': this.input.value,
            'add_on_type': this.input.dataset.type,
            'cost': Number(this.input.dataset.price),
          });
        }

        parentProperties['_add_on_variants'] = JSON.stringify(parentProperties['_add_on_variants']);

        fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: parentKey,
            quantity: Number(this.input.dataset.parentQuantity),
            properties: parentProperties,
          })
        })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            // Updates the cart drawer
            fetchCartDrawer(true);
          });
      } else {
        if (addonKey !== '') {
          const idToRemove = this.input.value;

          if (idToRemove !== '') {
            fetch(`${window.Shopify.routes.root}cart.js`)
              .then((response) => {
                return response.json();
              })
              .then((data) => {
                for (const item of data.items) {
                  if (
                    item.properties.hasOwnProperty('_uuid') &&
                    item.properties['_uuid'] === parentUUID
                  ) {
                    if (item.properties.hasOwnProperty('_add_on_variants')) {
                      const addOnVariants = JSON.parse(
                        item.properties['_add_on_variants']
                      );

                      if (addOnVariants.length > 0) {
                        addOnVariants.forEach((addOnVariant) => {
                          if (addOnVariant.id === idToRemove) {
                            addOnVariants.splice(
                              addOnVariants.indexOf(addOnVariant),
                              1
                            );
                          }
                        });
                      }

                      if (addOnVariants.length > 0) {
                        item.properties['_add_on_variants'] = JSON.stringify(addOnVariants);
                      } else {
                        delete item.properties['_add_on_variants'];
                      }
                    }

                    return fetch(
                      `${window.Shopify.routes.root}cart/change.js`,
                      {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                          id: item.key,
                          quantity: item.quantity,
                          properties: item.properties,
                        }),
                      }
                    );
                  }
                }
              })
              .catch((error) => {
                console.error(error);
              })
              .finally(() => {
                // Updates the cart drawer
                fetchCartDrawer(true);
              });
          }
        }
      }
    }
  });
}

window.addEventListener('focus', (event) => {
  fetchCartDrawer(false);
});